(function($) {
  $('input[type="text"], input[type="email"], input[type="password"]').change(function() {
    this.value = $.trim(noscript(this.value));
  });
  var done = window.location.hash;
  if (done) {
    if (done === '#done') {
      activeStep('done');
    }
  }
  const email = $('#email');
  const password = $('#password');
  const company_form = $('#company_form');
  const department = $('#department');
  const first_name = $('#first_name');
  const last_name = $('#last_name');
  const industry = $('#industry');
  const business = $('#business');
  const media = $('#media');
  const show_pass = $('#show_pass');
  const hide_pass = $('#hide_pass');
  const show_input_pass = $('#show_input_pass');
  const hide_input_pass = $('#hide_input_pass');
  // Validation
  function validationForm() {
    var result = true;
    // Mail
    if (email.val().length == 0) {
      result = false;
      handleError('email');
    } else {
      if (isEmail(email.val())) {
        handleError('email', false);
        mappingData('email', email.val());
      } else {
        result = false;
        handleError('email', true, '※メールアドレスは無効です');
      }
    }
    // Password
    if (password.val().length == 0) {
      result = false;
      handleError('password');
    } else {
      handleError('password', false);
      hidePass();
      // mappingData('password', password.val().replace(/./g, '•'));
    }
    // Company form
    if (company_form.val().length == 0) {
      result = false;
      handleError('company_form');
    } else {
      handleError('company_form', false);
      mappingData('company_form', company_form.val());
    }
    // First name
    if (first_name.val().length == 0) {
      result = false;
      handleError('first_name');
    } else {
      handleError('first_name', false);
      mappingData('first_name', first_name.val());
    }
    // Last name
    if (last_name.val().length == 0) {
      result = false;
      handleError('last_name');
    } else {
      handleError('last_name', false);
      mappingData('last_name', last_name.val());
    }
    // Industry
    if (industry.val().length == 0) {
      result = false;
      handleError('industry');
    } else {
      handleError('industry', false);
      mappingData('industry', industry.val());
    }
    // Business
    if (business.val().length == 0) {
      result = false;
      handleError('business');
    } else {
      handleError('business', false);
      mappingData('business', business.val());
    }
    // Media
    if (media.val().length == 0) {
      result = false;
      handleError('media');
    } else {
      handleError('media', false);
      mappingData('media', media.val());
    }

    return result;
  };
  function noscript(strCode){
    var html = $(strCode.bold()); 
    html.find('script').remove();
    return html.html();
  }
  // Mapping data
  function mappingData(fieldName, value) {
    var confirmEle = $('#c_' + fieldName);
    if (confirmEle) {
      confirmEle.html(value);
    }
  }

  // Mapping input
  function mappingDataUnRequire()
  {
    $('#c_department').html(department.val());
  }

  // Show password
  function showPass() {
    var confirmEle = $('#c_password');
    confirmEle.html(password.val());
    show_pass.hide();
    hide_pass.show();
  }
  // Hide password
  function hidePass() {
    var confirmEle = $('#c_password');
    confirmEle.html(password.val().replace(/./g, '•'));
    show_pass.show();
    hide_pass.hide();
  }

  // Show error message
  function handleError(fieldName, failed, message) {
    if(failed === undefined) {
      failed = true;
    }
    if(message === undefined) {
      message = '';
    }
    var fieldName = $('#e_' + fieldName);
    if (fieldName) {
      if (failed) {
        if (message == '') {message = '※未入力です。'}
        fieldName.html(message);
      } else {
        fieldName.html('');
      }
    }
  }

  $('#submitForm').click(function(e){
    e.preventDefault();
    if ($('#agree_policy').is(':checked') == false) {
      swal({
        title: "警告",
        text: "利用規約にチェックを入れてください",
        icon: "warning",
      });
      return false;
    }
    if ($('#agree_privacy').is(':checked') == false) {
      swal({
        title: "警告",
        text: "プライバシーポリシーにチェックを入れてください",
        icon: "warning",
      });
      return false;
    }
    if (validationForm()) {
      mappingDataUnRequire();
      activeStep('confirm');
    } else {
      window.scrollTo({top: 380, behavior: 'smooth'});
    }
  });
  $('#edit').click(function(e) {
    e.preventDefault();
    activeStep('inputForm');
  });
  var passEl = document.getElementById('password');
  $(show_input_pass).click(function() {
    show_input_pass.hide();
    hide_input_pass.show();
    passEl.type = 'text';
  });
  $(hide_input_pass).click(function() {
    show_input_pass.show();
    hide_input_pass.hide();
    passEl.type = 'password';
  });
  $(show_pass).click(function() {
    showPass();
  });
  $(hide_pass).click(function() {
    hidePass();
  });

  function activeStep(stepName) {
    window.scrollTo({top: 380});
    switch(stepName) {
      case 'inputForm':
        $('#formInput').show();
        $('#confirm').hide();
        $('#done').hide();

        $('#stepForm').addClass('on');
        $('#stepConfirm').removeClass('on');
        $('#stepDone').removeClass('on');
        break;
      case 'confirm':
        $('#formInput').hide();
        $('#confirm').show();
        $('#done').hide();

        $('#stepForm').removeClass('on');
        $('#stepConfirm').addClass('on');
        $('#stepDone').removeClass('on');
        break;
      case 'done':
        $('#formInput').hide();
        $('#confirm').hide();
        // $('#done').show();

        $('#stepForm').removeClass('on');
        $('#stepConfirm').removeClass('on');
        $('#stepDone').addClass('on');
        break;
      default:
    }
  }
  function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  };
}(jQuery));